import { ImgHTMLAttributes, useEffect, useState } from 'react';

interface ImagePropType extends ImgHTMLAttributes<HTMLImageElement> {
  defaultSrc: string;
}

export const Image = (props: ImagePropType) => {
  const { defaultSrc, src, ...rest } = props;
  const [imgSrc, setImgSrc] = useState(src || defaultSrc);

  useEffect(() => {
    if (!src) {
      setImgSrc(defaultSrc);
      return;
    }

    // Kiểm tra tải hình ảnh
    const img = new window.Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(src);
    };
    img.onerror = () => {
      setImgSrc(defaultSrc);
    };
  }, [src, defaultSrc]);

  return (
    <img
      src={imgSrc}
      style={{ borderRadius: '8px'}}
      alt=''
      onError={(e) => {
        (e.target as HTMLImageElement).src = defaultSrc;
      }}
      {...rest}
    />
  );
};